const state = {
    form: {}
}

const getters = {
    form: state => state.form
}

const mutations = {
    UPDATE_CAR_RENTAL_FORM(state, payload) {
        state.form = payload;
    }
}

const actions = {
    updateForm({ commit }, params) {
        console.log(params);
        commit('UPDATE_CAR_RENTAL_FORM', params);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}